import React from 'react';
import { smoothScrollToElement } from '../utils/scrollHelpers';
export function Hero() {
  const scrollToPricing = () => {
    smoothScrollToElement('pricing');
  };
  return <div className="pt-8 pb-6 px-4 max-w-5xl mx-auto" data-id="element-101">
      <div className="text-center mb-6" data-id="element-102">
        <div className="inline-block bg-red-50 border-2 border-red-500 rounded-lg px-4 py-2 font-body font-bold text-red-600 mb-4 text-[10px]" data-id="element-103">
          🧠 PARA PSICÓLOGOS QUE DOMINAN LA TEORÍA, PERO TEMEN LA PRÁCTICA
        </div>

        <h1 className="font-display text-brand-primary font-bold tracking-tight mb-6 md:text-5xl text-[28px]" data-id="element-104">
          DEJA DE IMPROVISAR Y EMPIEZA A EJERCER CON AUTORIDAD.
        </h1>
      </div>

      <div className="my-6 flex justify-center" data-id="element-105">
        <img src="https://cdn.magicpatterns.com/uploads/3kRHffD2vVFMHbK8ojt2we/mockup_webp_(2).webp" alt="PSICÓLOGO EN ACCIÓN" width="450" height="450" fetchPriority="high" loading="eager" decoding="async" className="w-full max-w-xl" data-id="element-106" />
      </div>

      <div className="text-center max-w-3xl mx-auto" data-id="element-107">
        <h2 className="font-display text-brand-accent md:text-2xl font-semibold mb-6 text-[18px]" data-id="element-108">
          Pasa de la inseguridad del recién graduado a la autoridad de un
          profesional con consulta privada. El sistema integral para abrir,
          captar y blindar tu práctica desde el primer paciente.
        </h2>

        <div className="bg-brand-accent/10 border-2 border-brand-accent rounded-lg p-4 mb-6" data-id="element-109">
          <p className="font-body text-brand-primary font-bold text-lg mb-2" data-id="element-110">
            📦 6 TOMOS + 200 PÁGINAS + 3 BONOS + PACK LEGAL
          </p>
          <p className="font-body text-brand-text text-sm" data-id="element-111">
            Sin síndrome del impostor • Sin improvisar • Sin depender de nadie
          </p>
        </div>

        <div className="flex items-center justify-center gap-3 mb-6 text-sm flex-wrap" data-id="element-112">
          <div className="flex text-brand-accent" data-id="element-113">⭐⭐⭐⭐⭐</div>
          <span className="font-body font-bold text-brand-primary" data-id="element-114">4.9/5</span>
          <span className="text-brand-textMuted" data-id="element-115">·</span>
          <span className="font-body text-brand-text font-semibold" data-id="element-116">
            +500 reseñas
          </span>
          <span className="text-brand-textMuted" data-id="element-117">·</span>
          <span className="font-body text-red-600 font-bold" data-id="element-118">
            🔥 38 compraron HOY
          </span>
        </div>

        <button onClick={scrollToPricing} className="bg-gradient-gold hover:opacity-90 text-brand-primary font-body font-bold text-xl md:text-2xl py-4 px-10 rounded-lg transition-all hover:shadow-gold w-full md:w-auto mb-3 animate-pulse" data-id="element-119">
          🚀 QUIERO EJERCER CON AUTORIDAD
        </button>

        <p className="text-brand-textMuted text-xs" data-id="element-120">
          ⏰ Precio de lanzamiento • Sube pronto
        </p>
      </div>
    </div>;
}